import * as React from 'react';
import Select from 'react-select';
import { VALIDATION_OPTIONS, Question } from '@nexxt/common/types';
import IndicatorsContainer from '../../../../common/reactSelect/IndicatorsContainer';
interface IValidationOptionProps {
    question: Question;
    questionError: any;
    disabled: boolean;
    setValue: (keyName: string, value: any) => void;
}

const ValidationOptionField: React.SFC<IValidationOptionProps> = (
    props: IValidationOptionProps
) => {
    const selectedOption = VALIDATION_OPTIONS.find(
        (opt) => opt.value === props.question.validationType
    );
    return (
        <div className="optional-blocks">
            <div className="form-group-header">Validation options</div>
            <Select
                className={'form-select--react-select react-select'}
                classNamePrefix="react-select"
                options={VALIDATION_OPTIONS}
                placeholder={'Please select the validation option...'}
                value={selectedOption}
                onChange={(option) =>
                    props.setValue('validationType', option.value)
                }
                component={IndicatorsContainer}
                isDisabled={props.disabled}
            />
            {props.questionError && props.questionError.validationType ? (
                <span className="form-group__error-msg">
                    {props.questionError.validationType}
                </span>
            ) : null}
        </div>
    );
};

export default ValidationOptionField;
